import { render, staticRenderFns } from "./AdminStreamsList.vue?vue&type=template&id=97bce992&scoped=true&"
import script from "./AdminStreamsList.vue?vue&type=script&lang=js&"
export * from "./AdminStreamsList.vue?vue&type=script&lang=js&"
import style0 from "./AdminStreamsList.vue?vue&type=style&index=0&id=97bce992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bce992",
  null
  
)

export default component.exports